// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { mobile16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-mobile': IconMobile;
    }
}

/**
 * The icon component for the 'mobile' icon
 */
export class IconMobile extends IconSvg {
    public constructor() {
        super(mobile16X16);
    }
}

registerIconSvg('icon-mobile', IconMobile);
export const iconMobileTag = 'nimble-icon-mobile';
